
import { useMemo } from "react"
import { updateRenterProps } from "../../../../../common/services/renters.api"
import { FileInputPdf } from "../../../../../common/components/form/FileInputPdf"
import { FileUploadRenters } from "./FileUploadRenters";

type DocumentRenterRowProps = {
  renterId: string;
  currentPathRescisao: string;
  currentPath?: string[];
}

export function RenterDocumentsRow(props: DocumentRenterRowProps) {
  const pathToUpload = useMemo(() => `customers/${props.renterId}`, [props.renterId])

  const saveRenterContract = async (contratoPdfIleva) => {
    const contractUploadArray = Array.isArray(contratoPdfIleva) ? contratoPdfIleva : [contratoPdfIleva];
    await updateRenterProps(props.renterId, {
      contratoPdfIleva: contractUploadArray,
    })
  }

  const saveRenterRescisao = async (rescisaoPdf) => {
    await updateRenterProps(props.renterId, {
      rescisaoPdf,
    })
  }

  return (
    <div className="col-span-3">
      <h2 className="text-2xl font-semibold mb-4">Documentos do cliente</h2>
      <div className="flex flex-col items-stretch ">
        {props.currentPath && (
          <div>
            <h3 className="font-bold ml-2">Contrato</h3>
            <FileUploadRenters
              onChange={saveRenterContract}
              pathToUpload={pathToUpload}
              currentPath={props.currentPath}
            />
          </div>
        )}
        <h3 className="font-bold ml-2">Atestado médico</h3>
        <FileInputPdf
          onChange={saveRenterRescisao}
          pathToUpload={pathToUpload}
          currentPath={props.currentPathRescisao}
          nameFile="Enviar atestado médico"
        />
      </div>
    </div>
  );
}